import React from 'react';
import {
  HashRouter,
  Navigate,
  Route,
  Routes
} from 'react-router-dom';
import AdminPanel from './pages/AdminPanel';
import LivePlatform from './pages/LivePlatform';

export default function App() {
  // Redirigir la ruta física /admin al formato de HashRouter /#/admin
  // Esto asegura que al entrar directamente a la URL funcione correctamente
  if (window.location.pathname === '/admin' || window.location.pathname === '/admin/') {
    window.location.replace('/#/admin');
    return null;
  }

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<LivePlatform />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}